import "./FormBanner.css";

export default function FormBanner() {
    return (
        <section className="form-banner" dir="ltr">
            <div className="form-banner__content" dir="rtl">
                <img src="assets/formBanner.png" alt="..." />
            </div>
        </section>
    );
}